import { IS_COMPANY_ROUTER_FRONTEND } from "../globals";
import type { NotificationKind, UiNotification } from "./openapi-aliases";
import { connectReconnectingSocket } from "./low_level";
import { get_company_api_url } from "./openapi_clients";

let started = false;

// Reactions beyond display, keyed by notification kind; feature modules
// register their own (wired up in App.tsx).
const kindHandlers = new Map<NotificationKind, (notification: UiNotification) => void>();

export const onNotificationKind = (
  kind: NotificationKind,
  handler: (notification: UiNotification) => void,
) => {
  kindHandlers.set(kind, handler);
};

const display = (notification: UiNotification) => {
  if (notification.kind) {
    kindHandlers.get(notification.kind)?.(notification);
  }
  // Without OS permission (never requested in the browser, see App.tsx) the
  // kind handler above is deliberately the whole effect.
  if ("Notification" in window && Notification.permission === "granted") {
    const shown = new Notification(notification.title, {
      body: notification.body,
      icon: notification.icon ?? undefined,
    });
    shown.onclick = () => {
      window.focus();
      if (notification.url) {
        window.location.assign(notification.url);
      }
    };
  }
};

/**
 * Notification delivery: the desktop core broadcasts its local events over
 * `/ws/notifications/`, the company router pushes the caller's own alerts
 * over `/ws/clank/notifications/`. Both feed the same display. A click
 * focuses the app — which in the Electron shell also un-hides a tray-hidden
 * window.
 */
export const connectNotifications = () => {
  if (started) return;
  started = true;

  // The local socket only exists under the desktop shell.
  if (!IS_COMPANY_ROUTER_FRONTEND) {
    connectReconnectingSocket<UiNotification>("/ws/notifications/", display);
  }
  // The company router's base URL comes from config, which may still be
  // loading: the getter throws until then, and the socket simply retries.
  connectReconnectingSocket<UiNotification>(
    "/ws/clank/notifications/",
    display,
    get_company_api_url,
  );
};
